import { createAsyncThunk } from "@reduxjs/toolkit";
import { FinancialDashboardAPIService } from "src/constants";
import { sendRequestJSON } from "src/lib/axios";
import { toastMessage } from "../commonSlice";
import { IFetchRevenueByStatusPayload } from "./types";

export const fetchTotalSales = createAsyncThunk(
  "financialDashboard/fetchTotalSales",
  async ({ branchId }: { branchId?: number }, { dispatch }) => {
    try {
      const query = branchId ? `?branchId=${branchId}` : "";

      const response = await sendRequestJSON(
        null,
        `${FinancialDashboardAPIService.GET_TOTAL_REVENUE}${query}`,
        "get"
      );
      if (response && !response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchTotalInvoices = createAsyncThunk(
  "financialDashboard/fetchTotalInvoices",
  async ({ branchId }: { branchId?: number }, { dispatch }) => {
    try {
      const query = branchId ? `?branchId=${branchId}` : "";
      const response = await sendRequestJSON(
        null,
        `${FinancialDashboardAPIService.GET_REVENUE_BY_PAYMENT}${query}`,
        "get"
      );
      if (response && !response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchRevenueByStatus = createAsyncThunk(
  "financialDashboard/fetchRevenueByStatus",
  async (
    revenueByStatusPayload: IFetchRevenueByStatusPayload,
    { dispatch }
  ) => {
    try {
      const payload = new URLSearchParams({
        startDate: revenueByStatusPayload.startDate,
        endDate: revenueByStatusPayload.endDate,
      });

      if (
        revenueByStatusPayload.branchId !== undefined &&
        revenueByStatusPayload.branchId !== null &&
        revenueByStatusPayload.branchId !== -1
      ) {
        payload.append("branchId", revenueByStatusPayload.branchId.toString());
      }
      const response = await sendRequestJSON(
        null,
        FinancialDashboardAPIService.GET_REVENUE_BY_STATUS +
          `?${payload.toString()}`,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchPaymentMethodCount = createAsyncThunk(
  "financialDashboard/fetchPaymentMethodCount",
  async ({ branchId }: { branchId?: number }, { dispatch }) => {
    try {
      const query = branchId ? `?branchId=${branchId}` : "";

      const response = await sendRequestJSON(
        null,
        `${FinancialDashboardAPIService.GET_PAYMENT_METHOD_COUNT}${query}`,
        "get"
      );
      if (response && !response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchRecentInvoices = createAsyncThunk(
  "financialDashboard/fetchRecentInvoices",
  async (recentInvoicesPayload: IFetchRevenueByStatusPayload, { dispatch }) => {
    try {
      const payload = new URLSearchParams({
        startDate: recentInvoicesPayload.startDate,
        endDate: recentInvoicesPayload.endDate,
      });

      if (
        recentInvoicesPayload.branchId !== undefined &&
        recentInvoicesPayload.branchId !== null &&
        recentInvoicesPayload.branchId !== -1
      ) {
        payload.append("branchId", recentInvoicesPayload.branchId.toString());
      }

      const response = await sendRequestJSON(
        null,
        FinancialDashboardAPIService.GET_RECENT_INVOICES +
          `?${payload.toString()}`,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const downloadReport = createAsyncThunk(
  "financialDashboard/downloadReport",
  async (recentInvoicesPayload: IFetchRevenueByStatusPayload, { dispatch }) => {
    try {
      const queryParams = new URLSearchParams({
        startDate: recentInvoicesPayload.startDate,
        endDate: recentInvoicesPayload.endDate,
      });
      // console.log("recentInvoicesPayload", recentInvoicesPayload);

      if (
        recentInvoicesPayload.branchId &&
        recentInvoicesPayload.branchId !== 0
      ) {
        queryParams.append("branchId", String(recentInvoicesPayload.branchId));
      }

      const response = await sendRequestJSON(
        null,
        `${
          FinancialDashboardAPIService.DOWNLOAD_REPORT
        }?${queryParams.toString()}`,
        "get"
      );

      if (response && !response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error: any) {
      dispatch(
        toastMessage({
          error: true,
          message: error?.response?.data || "Failed to download report",
        })
      );
      return [];
    }
  }
);
